/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { DocumentAdminControllerPreviewOrphanedDocumentReconciliationQueryResponse, DocumentAdminControllerPreviewOrphanedDocumentReconciliation400, DocumentAdminControllerPreviewOrphanedDocumentReconciliation401, DocumentAdminControllerPreviewOrphanedDocumentReconciliation403, DocumentAdminControllerPreviewOrphanedDocumentReconciliation404 } from "../../models/documentAdminController/DocumentAdminControllerPreviewOrphanedDocumentReconciliation";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { documentAdminControllerPreviewOrphanedDocumentReconciliation } from "../../clients/document-adminService/documentAdminControllerPreviewOrphanedDocumentReconciliation";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const documentAdminControllerPreviewOrphanedDocumentReconciliationQueryKey = () => [{
  url: '/api/v1/documents/orphaned-document-reconciliations/preview'
}] as const;
export type DocumentAdminControllerPreviewOrphanedDocumentReconciliationQueryKey = ReturnType<typeof documentAdminControllerPreviewOrphanedDocumentReconciliationQueryKey>;
export function documentAdminControllerPreviewOrphanedDocumentReconciliationQueryOptions(config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = documentAdminControllerPreviewOrphanedDocumentReconciliationQueryKey();
  return queryOptions<DocumentAdminControllerPreviewOrphanedDocumentReconciliationQueryResponse, ResponseErrorConfig<DocumentAdminControllerPreviewOrphanedDocumentReconciliation400 | DocumentAdminControllerPreviewOrphanedDocumentReconciliation401 | DocumentAdminControllerPreviewOrphanedDocumentReconciliation403 | DocumentAdminControllerPreviewOrphanedDocumentReconciliation404>, DocumentAdminControllerPreviewOrphanedDocumentReconciliationQueryResponse, typeof queryKey>({
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return documentAdminControllerPreviewOrphanedDocumentReconciliation(config);
    }
  });
}

/**
 * @description Admin/service-account endpoint. Read-only: detects documents still ACTIVE whose source file has been soft-deleted and returns them without changing any data. Use this to see what a reconciliation would do before approving it, and again afterwards to verify.
 * @summary Preview orphaned ACTIVE documents whose source file is deleted
 * {@link /api/v1/documents/orphaned-document-reconciliations/preview}
 */
export function useDocumentAdminControllerPreviewOrphanedDocumentReconciliation<TData = DocumentAdminControllerPreviewOrphanedDocumentReconciliationQueryResponse, TQueryData = DocumentAdminControllerPreviewOrphanedDocumentReconciliationQueryResponse, TQueryKey extends QueryKey = DocumentAdminControllerPreviewOrphanedDocumentReconciliationQueryKey>(options: {
  query?: Partial<QueryObserverOptions<DocumentAdminControllerPreviewOrphanedDocumentReconciliationQueryResponse, ResponseErrorConfig<DocumentAdminControllerPreviewOrphanedDocumentReconciliation400 | DocumentAdminControllerPreviewOrphanedDocumentReconciliation401 | DocumentAdminControllerPreviewOrphanedDocumentReconciliation403 | DocumentAdminControllerPreviewOrphanedDocumentReconciliation404>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? documentAdminControllerPreviewOrphanedDocumentReconciliationQueryKey();
  const query = useQuery({
    ...documentAdminControllerPreviewOrphanedDocumentReconciliationQueryOptions(config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<DocumentAdminControllerPreviewOrphanedDocumentReconciliation400 | DocumentAdminControllerPreviewOrphanedDocumentReconciliation401 | DocumentAdminControllerPreviewOrphanedDocumentReconciliation403 | DocumentAdminControllerPreviewOrphanedDocumentReconciliation404>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}